import React, { useEffect, useState } from "react";

const Sorulan_Sorular = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 600;
  const isTablet = windowWidth > 600 && windowWidth <= 992;

  const questions = [
    {
      id: 1,
      question: "Neden metrekare birim fiyatına bakmalıyım?",
      answer:
        "Evin toplam fiyatı benzer olsa bile metrekare boyutları değişebileceği için karşılaştırma yapmak zorlaşır. Metrekare birim fiyatı, hangi projenin daha avantajlı olduğunu anlamanızı sağlar.",
    },
    {
      id: 2,
      question: "Net ve brüt metrekare arasındaki fark nedir?",
      answer:
        "Net metrekare: Dairenin gerçek kullanılabilir alanıdır (temiz alan).\nBrüt metrekare: Ortak alanlar dahil geniş hesaptır.\nBrüt alana nelerin dahil edildiğini mutlaka sözleşmede kontrol edin. İdeal fark %30-35, bazı projelerde %50'ye kadar çıkabilir.",
    },
    {
      id: 3,
      question: "Ödeme planında nelere dikkat edilmeli?",
      answer:
        "Taksitlerin düşük olması yanıltıcı olabilir. Ara ödeme tarihlerini ve miktarlarını kontrol edin, gelirinizle uyumlu olup olmadığını değerlendirin ve gerekirse plan değişikliği isteyin.",
    },
    {
      id: 4,
      question: "Teslim tarihi neden önemli?",
      answer:
        "Eve ne zaman taşınabileceğinizi veya kira geliri almaya ne zaman başlayacağınızı bilmeniz için teslim tarihini öğrenin. İnşaatın yaşanabilir hale gelme tarihini netleştirin.",
    },
    {
      id: 5,
      question: "Teslimde gecikme durumunda ne olur?",
      answer:
        "Gecikme süresi en fazla 6 ay olmalıdır. Gecikme halinde firmanın ne kadar tazminat ödeyeceğini sözleşmede kontrol edin.",
    },
    {
      id: 6,
      question: "Teknik şartname neden incelenmeli?",
      answer:
        "Kullanılacak malzemelerin markası ve kalitesi şartnamede yazmalıdır. Standartları kontrol etmezseniz örnek dairede gördüğünüzden daha düşük kalite çıkabilir.",
    },
    {
      id: 7,
      question: "Örnek daire gerçek daireyle aynı mı?",
      answer:
        "Örnek dairedeki tüm özelliklerin teslimde uygulanıp uygulanmayacağını sorun. Bazı dekorasyon ve malzemeler sadece teşhir amaçlı olabilir.",
    },
    {
      id: 8,
      question: "Otopark detayı neden önemli?",
      answer:
        "Her projede otopark bulunsa da açık/kapalı, tahsisli olup olmadığı ve kapasitesi çok önemlidir. Yeriniz garanti olsun diye tahsisli otopark tercih edin.",
    },
    {
      id: 9,
      question: "İnşaat firmasının geçmiş projelerine bakmalı mıyım?",
      answer:
        "Evet. Firmanın teslimleri zamanında yapıp yapmadığını, eski projelerde şikâyet olup olmadığını araştırın.",
    },
    {
      id: 10,
      question: "Aidatlar nasıl değerlendirilir?",
      answer:
        "Aidatların seviyesini mutlaka öğrenin. Bazı projelerde aidatlar kira seviyesine kadar çıkabilir. Bütçenizi zorlamayan bir proje seçin.",
    },
  ];

  const styles = {
    page: {
      backgroundColor: "#f7f7f7",
      minHeight: "100vh",
      padding: isMobile ? "30px 10px" : isTablet ? "40px 20px" : "60px 20px",
      display: "flex",
      justifyContent: "center",
    },
    container: {
      maxWidth: isMobile ? "100%" : isTablet ? "90%" : "900px",
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: isMobile ? "25px 20px" : "40px 30px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      lineHeight: "1.7",
    },
    title: {
      fontSize: isMobile ? "18px" : "24px",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: "25px",
      color: "#222",
    },
    text: {
      fontSize: isMobile ? "13px" : "14px",
      color: "#555",
      marginBottom: "10px",
      lineHeight: "1.6",
      textAlign: isMobile ? "justify" : "left",
    },
    questionItem: {
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      marginBottom: "20px",
      overflow: "hidden",
    },
    questionHeader: {
      backgroundColor: "#f8f9fa",
      padding: isMobile ? "15px" : "20px",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "flex-start" : "center",
      gap: "10px",
    },
    questionNumber: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#001E78",
      flexShrink: 0,
    },
    questionTitle: {
      fontSize: isMobile ? "15px" : "16px",
      fontWeight: "600",
      color: "#333",
      margin: 0,
      lineHeight: "1.4",
    },
    answerSection: {
      padding: isMobile ? "15px" : "20px",
      backgroundColor: "#fff",
    },
    answerText: {
      fontSize: isMobile ? "13px" : "14px",
      color: "#555",
    },
    contactSection: {
      backgroundColor: "#f0f7ff",
      padding: isMobile ? "20px" : "30px",
      borderRadius: "8px",
      border: "1px solid #cfe2ff",
      textAlign: "center",
      marginBottom: "25px",
    },
    contactTitle: {
      fontSize: isMobile ? "16px" : "18px",
      fontWeight: "600",
      color: "#001E78",
      marginBottom: "10px",
    },
    contactText: {
      fontSize: isMobile ? "13px" : "14px",
      color: "#555",
      marginBottom: "20px",
      lineHeight: "1.6",
    },
    contactButtons: {
      display: "flex",
      gap: "10px",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    contactButton: {
      backgroundColor: "#001E78",
      color: "white",
      padding: isMobile ? "10px 14px" : "12px 20px",
      borderRadius: "6px",
      textDecoration: "none",
      fontSize: isMobile ? "13px" : "14px",
      fontWeight: "600",
      transition: "all 0.3s ease",
      minWidth: isMobile ? "130px" : "160px",
      textAlign: "center",
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>MÜŞTERİLERİMİZİN SORDUĞU SORULAR</h1>

        <section>
          <p style={styles.text}>
            Aşağıda müşterilerimizin en çok sorduğu soruları ve detaylı
            cevaplarını bulabilirsiniz. Eğer aradığınız soruyu bulamazsanız,
            bizimle iletişime geçmekten çekinmeyin.
          </p>
        </section>

        <div>
          {questions.map((item, index) => (
            <div key={item.id} style={styles.questionItem}>
              <div style={styles.questionHeader}>
                <span style={styles.questionNumber}>{index + 1}.</span>
                <h3 style={styles.questionTitle}>{item.question}</h3>
              </div>
              <div style={styles.answerSection}>
                <div style={styles.answerText}>
                  {item.answer.split("\n").map((line, i) => (
                    <p key={i} style={{ margin: "8px 0", lineHeight: "1.6" }}>
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <section style={styles.contactSection}>
          <h2 style={styles.contactTitle}>Başka Sorunuz Mu Var?</h2>
          <p style={styles.contactText}>
            Yukarıdaki sorular size yardımcı olamadıysa, lütfen bizimle
            iletişime geçin. Size en kısa sürede dönüş yapacağız.
          </p>
          <div style={styles.contactButtons}>
            <a href="/iletisim" style={styles.contactButton}>
              İletişim Sayfasına Git
            </a>
            <a href="mailto:destek@temelden.com.tr" style={styles.contactButton}>
              E-posta Gönder
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Sorulan_Sorular;
